// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"493":"e6caf6e5","889":"b21659c3"}[chunkId] + ".chunk.js";
};